/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the FaceScanApiConfiguration configuration object with a given root URL.
 */
export function provideFaceScanApiConfiguration(rootUrl: string) {
  var config = new FaceScanApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: FaceScanApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class FaceScanApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `FaceScanModule.forRoot()`
 */
export interface FaceScanApiConfigurationParams {
  rootUrl?: string;
}
